import * as tslib_1 from "tslib";
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "apollo-angular";
var ChangeAvatarService = /** @class */ (function () {
    function ChangeAvatarService(apollo) {
        this.apollo = apollo;
    }
    ChangeAvatarService.prototype.updateUser = function (_a) {
        var id = _a.id, input = _a.input;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_b) {
                return [2 /*return*/, this.apollo
                        .query({
                        query: gql(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n          mutation updateUser($id: ID!, $input: UserInput!) {\n            updateUser(id: $id, input: $input) {\n              id\n            }\n          }\n        "], ["\n          mutation updateUser($id: ID!, $input: UserInput!) {\n            updateUser(id: $id, input: $input) {\n              id\n            }\n          }\n        "]))),
                        variables: {
                            id: id,
                            input: input
                        }
                    })
                        .toPromise()
                        .then(function (result) { return result.data['updateUser']; })];
            });
        });
    };
    ChangeAvatarService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ChangeAvatarService_Factory() { return new ChangeAvatarService(i0.ɵɵinject(i1.Apollo)); }, token: ChangeAvatarService, providedIn: "root" });
    return ChangeAvatarService;
}());
export { ChangeAvatarService };
var templateObject_1;
